import React from "react";
import { useLang } from "@/lib/LanguageContext";

export default function Privacy() {
  const { t } = useLang();
  return (
    <div className="min-h-screen max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="privacy-page">
      <h1 className="font-heading text-3xl sm:text-4xl tracking-tight font-medium text-white mb-8">
        {t("privacyTitle")}
      </h1>
      <div className="prose-dark space-y-6 text-stone-400 text-sm leading-relaxed">
        <p><strong className="text-white">Date d'effet :</strong> 13 avril 2026</p>
        <section>
          <h2 className="text-lg font-medium text-white mt-8 mb-3">1. Collecte des donn&#233;es</h2>
          <p>Nous collectons les informations suivantes lorsque vous utilisez What To Cook :</p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Informations de compte : nom, adresse e-mail, mot de passe (chiffr&#233;)</li>
            <li>Donn&#233;es d'utilisation : ingr&#233;dients recherch&#233;s, recettes g&#233;n&#233;r&#233;es, pr&#233;f&#233;rences culinaires</li>
            <li>Informations de paiement : trait&#233;es de mani&#232;re s&#233;curis&#233;e via Stripe</li>
          </ul>
        </section>
        <section>
          <h2 className="text-lg font-medium text-white mt-8 mb-3">2. Utilisation des donn&#233;es</h2>
          <p>Vos donn&#233;es sont utilis&#233;es pour :</p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Fournir et am&#233;liorer le service de g&#233;n&#233;ration de recettes</li>
            <li>Personnaliser votre exp&#233;rience culinaire</li>
            <li>G&#233;rer votre abonnement et vos paiements</li>
            <li>Vous envoyer des notifications de service importantes</li>
          </ul>
        </section>
        <section>
          <h2 className="text-lg font-medium text-white mt-8 mb-3">3. Protection des donn&#233;es</h2>
          <p>Nous mettons en &#339;uvre des mesures de s&#233;curit&#233; appropri&#233;es pour prot&#233;ger vos informations personnelles contre tout acc&#232;s non autoris&#233;, modification, divulgation ou destruction.</p>
        </section>
        <section>
          <h2 className="text-lg font-medium text-white mt-8 mb-3">4. Partage des donn&#233;es</h2>
          <p>Nous ne vendons, n'&#233;changeons ni ne louons vos informations personnelles &#224; des tiers. Nous pouvons partager des informations avec des prestataires de services de confiance qui nous assistent dans l'exploitation de notre application.</p>
        </section>
        <section>
          <h2 className="text-lg font-medium text-white mt-8 mb-3">5. Vos droits</h2>
          <p>Vous avez le droit de :</p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Acc&#233;der &#224; vos donn&#233;es personnelles</li>
            <li>Rectifier vos informations</li>
            <li>Supprimer votre compte et vos donn&#233;es</li>
            <li>Exporter vos donn&#233;es</li>
          </ul>
        </section>
        <section>
          <h2 className="text-lg font-medium text-white mt-8 mb-3">6. Cookies</h2>
          <p>Nous utilisons des cookies essentiels pour le fonctionnement de l'application, notamment pour maintenir votre session de connexion et vos pr&#233;f&#233;rences de langue.</p>
        </section>
        <section>
          <h2 className="text-lg font-medium text-white mt-8 mb-3">7. Contact</h2>
          <p>Pour toute question concernant cette politique de confidentialit&#233;, contactez-nous &#224; : <span className="text-amber-500">support@k2what-to-cook.com</span></p>
        </section>
      </div>
    </div>
  );
}
